export default __webpack_public_path__ + "static/media/no_notification.33f5a1a3.svg";